import { render, staticRenderFns } from "./resume-tags.vue?vue&type=template&id=0ffc33f1&"
import script from "./resume-tags.vue?vue&type=script&lang=js&"
export * from "./resume-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports